document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('pre-sale-confirmation-modal');

  if (!modal) return;

  const shippingMessage = modal.querySelector(
    '.pre-sale-confirmation-modal__shipping-message'
  );
  const checkbox = modal.querySelector(
    '.pre-sale-confirmation-modal__checkbox'
  );
  const confirmButton = modal.querySelector(
    '.pre-sale-confirmation-modal__confirm'
  );
  const cancelButton = modal.querySelector(
    '.pre-sale-confirmation-modal__cancel'
  );
  const closeButton = modal.querySelector(
    '.pre-sale-confirmation-modal__close'
  );
  const overlay = modal.querySelector(
    '.pre-sale-confirmation-modal__overlay'
  );

  let pendingForm = null;
  let pendingSubmitter = null;
  let allowSubmission = false;

  function openModal(form, submitter) {
    const preSaleData = form.querySelector('.pre-sale-product-data');

    if (!preSaleData) return;

    pendingForm = form;
    pendingSubmitter =
      submitter || form.querySelector('[type="submit"][name="add"]');

    shippingMessage.textContent = preSaleData.textContent.trim();

    checkbox.checked = false;
    confirmButton.disabled = true;

    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    checkbox.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';

    checkbox.checked = false;
    confirmButton.disabled = true;

    pendingForm = null;
    pendingSubmitter = null;
  }

  document.addEventListener(
  'click',
  function (event) {
    const button = event.target.closest(
  'form.product-purchase-form #dynamic-atc-btn, form.product-purchase-form [type="submit"][name="add"]'
);

    if (!button) return;

    const form = button.closest('form.product-purchase-form');

    if (!form) return;

    if (allowSubmission) {
      return;
    }

    const preSaleData = form.querySelector('.pre-sale-product-data');

    if (!preSaleData) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    openModal(form, button);
  },
  true
);

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (
        !(form instanceof HTMLFormElement) ||
        !form.matches('form.product-purchase-form')
      ) {
        return;
      }

      if (allowSubmission) {
        allowSubmission = false;
        return;
      }

      const preSaleData = form.querySelector('.pre-sale-product-data');

      if (!preSaleData) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      openModal(form, event.submitter);
    },
    true
  );

  checkbox.addEventListener('change', function () {
    confirmButton.disabled = !checkbox.checked;
  });

  confirmButton.addEventListener('click', function () {
    if (!checkbox.checked || !pendingForm) return;

    const form = pendingForm;
    const submitter = pendingSubmitter;
    const preSaleData = form.querySelector('.pre-sale-product-data');

    const shippingWindow = preSaleData
      ? preSaleData.dataset.shippingWindow || ''
      : '';

    let acknowledgementInput = form.querySelector(
      'input[name="properties[_Pre-Sale Acknowledged]"]'
    );

    if (!acknowledgementInput) {
      acknowledgementInput = document.createElement('input');
      acknowledgementInput.type = 'hidden';
      acknowledgementInput.name = 'properties[_Pre-Sale Acknowledged]';
      form.appendChild(acknowledgementInput);
    }

    acknowledgementInput.value = 'Yes';

    let shippingInput = form.querySelector(
      'input[name="properties[_Pre-Sale Shipping Window]"]'
    );

    if (!shippingInput) {
      shippingInput = document.createElement('input');
      shippingInput.type = 'hidden';
      shippingInput.name = 'properties[_Pre-Sale Shipping Window]';
      form.appendChild(shippingInput);
    }

    shippingInput.value = shippingWindow;

    modal.hidden = true;
    document.body.style.overflow = '';

    allowSubmission = true;

   if (submitter) {
  submitter.click();
} else if (typeof form.requestSubmit === 'function') {
  form.requestSubmit();
} else {
  form.submit();
}

    pendingForm = null;
    pendingSubmitter = null;
  });

  cancelButton.addEventListener('click', closeModal);
  closeButton.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
});